import { extends as _extends, objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useListContext } from './list-context.esm.js';
import { LIST_THEME_KEY } from './types.esm.js';
import { __DEV__ } from '../../utils/assertion.esm.js';
import { createUseStyledComponent } from '../../hooks/use-styled-component.esm.js';

var _excluded = ["variant", "className", "color", "lineHeight", "as", "disableGutters", "disableSticky", "inset"];
var useStyledComponent = createUseStyledComponent(['li'], 'csg-list-subheader');
var ListSubheaderPrivate = /*#__PURE__*/React.forwardRef(function ListSubheaderPrivate(props, ref) {
  var _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'listSubheader' : _props$variant,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'neutral.dark' : _props$color,
    _props$lineHeight = props.lineHeight,
    lineHeight = _props$lineHeight === void 0 ? 2 : _props$lineHeight,
    _props$as = props.as,
    component = _props$as === void 0 ? 'li' : _props$as,
    _props$disableGutters = props.disableGutters,
    disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
    _props$disableSticky = props.disableSticky,
    disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
    _props$inset = props.inset,
    inset = _props$inset === void 0 ? false : _props$inset,
    rest = _objectWithoutProperties(props, _excluded);
  var _useListContext = useListContext(),
    dense = _useListContext.dense,
    listVariant = _useListContext.variant;
  var Component = useStyledComponent(component);
  var __css = useMemo(function () {
    return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      color: color
    }, lineHeight ? {
      lineHeight: lineHeight
    } : {}), inset ? {
      pl: '72px'
    } : {}), !disableSticky ? {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'white'
    } : {}), !disableGutters ? {
      px: dense ? 'xs' : 'md'
    } : {});
  }, [color, dense, disableGutters, disableSticky, inset, lineHeight]);
  return /*#__PURE__*/React.createElement(Component
  // until there are use case where this component is used in the a compound component we keep it simple
  , _extends({
    variant: listVariant ? "".concat(listVariant, ".listSubheader") : variant,
    __themeKey: LIST_THEME_KEY,
    ref: ref,
    className: classNames('csg-tui-list-subheader', className),
    __css: __css
  }, rest));
});
var MemoListSubheader = /*#__PURE__*/React.memo(ListSubheaderPrivate);
var ListSubheader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(MemoListSubheader, _extends({
    ref: ref
  }, props));
});
if (__DEV__) {
  ListSubheader.displayName = 'ListSubheader';
}

export default ListSubheader;
//# sourceMappingURL=list-subheader.esm.js.map
